import React from 'react';
import { CleaveInput } from '@cp-shared-19/frontend-ui';

type PhonenumberInputProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
    inputId?: string;
};

export const PhonenumberInput: React.FC<PhonenumberInputProps> = ({ label, name, isMandatory, inputId }) => {
    return (
        <CleaveInput
            requiredText=" *"
            className="c-form-field--no-floating"
            cleaveOptions={{
                delimiter: '',
                blocks: [10],
                numericOnly: true,
            }}
            inputMode={'numeric'}
            label={label}
            name={name}
            inputId={inputId}
            testId={`test-${name}`}
            aria-required={isMandatory}
            isMandatory={isMandatory}
            autocomplete="tel"
        />
    );
};
